<template>
    <div class="service-picker-container">
        <div v-if="hasAnyServiceEnabled" class="service-section">
            <h2 class="service-header">Select Your Service</h2>
            <div class="service-grid">
            <!-- Remote Online Notary -->
            <div v-if="Store.TenantConfig.isServiceEnabledRONNotarization" class="service-card-wrapper">
                <div @click="CmdSelectService('RONNotarization')" class="service-card" :class="{ 'selected': Store.Checkout.Cart.SelectedService === 'RONNotarization' }">
                    <div class="service-icon">
                        <i class="bi-camera-video"></i>
                    </div>
                    <div class="service-content">
                        <h3 class="service-title">Remote Online Notary</h3>
                        <p class="service-description">Connect with a notary instantly via secure video call</p>
                    </div>
                    <div class="service-arrow">
                        <i class="bi-arrow-right"></i>
                    </div>
                </div>
            </div>

            <!-- Mobile Notary -->
            <div v-if="Store.TenantConfig.isServiceEnabledFieldNotarization" class="service-card-wrapper">
                <div @click="CmdSelectService('FieldNotarization')" class="service-card" :class="{ 'selected': Store.Checkout.Cart.SelectedService === 'FieldNotarization' }">
                    <div class="service-icon">
                        <i class="bi-geo-alt"></i>
                    </div>
                    <div class="service-content">
                        <h3 class="service-title">Mobile Notary</h3>
                        <p class="service-description">Professional notary comes to your location</p>
                    </div>
                    <div class="service-arrow">
                        <i class="bi-arrow-right"></i>
                    </div>
                </div>
            </div>

            <!-- Courier Delivery -->
            <div v-if="Store.TenantConfig.isServiceEnabledCourier" class="service-card-wrapper">
                <div @click="CmdSelectService('CourierDelivery')" class="service-card" :class="{ 'selected': Store.Checkout.Cart.SelectedService === 'CourierDelivery' }">
                    <div class="service-icon">
                        <i class="bi-truck"></i>
                    </div>
                    <div class="service-content">
                        <h3 class="service-title">Courier Delivery</h3>
                        <p class="service-description">Fast and reliable document pickup & delivery</p>
                    </div>
                    <div class="service-arrow">
                        <i class="bi-arrow-right"></i>
                    </div>
                </div>
            </div>

            <!-- Apostille Service -->
            <div v-if="Store.TenantConfig.isServiceEnabledApostille" class="service-card-wrapper">
                <div @click="CmdSelectService('Apostille')" class="service-card" :class="{ 'selected': Store.Checkout.Cart.SelectedService === 'Apostille' }">
                    <div class="service-icon">
                        <i class="bi-award"></i>
                    </div>
                    <div class="service-content">
                        <h3 class="service-title">Apostille Service</h3>
                        <p class="service-description">International document authentication</p>
                    </div>
                    <div class="service-arrow">
                        <i class="bi-arrow-right"></i>
                    </div>
                </div>
            </div>

            <!-- Field Inspection -->
            <div v-if="Store.TenantConfig.isServiceEnabledFieldInspection" class="service-card-wrapper">
                <div @click="CmdSelectService('FieldInspection')" class="service-card" :class="{ 'selected': Store.Checkout.Cart.SelectedService === 'FieldInspection' }">
                    <div class="service-icon">
                        <i class="bi-search"></i>
                    </div>
                    <div class="service-content">
                        <h3 class="service-title">Field Inspection</h3>
                        <p class="service-description">Professional property and asset verification</p>
                    </div>
                    <div class="service-arrow">
                        <i class="bi-arrow-right"></i>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <!-- No Services Available -->
        <div v-else class="no-services-container">
            <div class="no-services-content">
                <div class="no-services-icon">
                    <i class="bi bi-info-circle"></i>
                </div>
                <h3>No Services Available</h3>
                <p>We're currently updating our service offerings. Please contact our support team for assistance with your needs.</p>
                <a href="/contact" class="btn btn-primary">
                    <i class="bi bi-envelope me-2"></i>Contact Support
                </a>
            </div>
        </div>
    </div>
</template>

<script>

    import { nextTick } from 'vue';
import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';

    export default {
        name: 'CheckoutServicePicker',
        components: {
        },
        props: {
        },
        data() {
            return {
                Store: {},
                urlServiceParam: null
            };
        },
        methods:
        {
            CmdSelectService: function (svc) {                
                this.Store.Checkout.Cart.SelectedService = svc;               
                this.Store.SetNextStep();
            },
            onCartLoaded: function(cart) {
                // Use nextTick to ensure DOM is updated
                this.$nextTick(() => {
                    if (this.urlServiceParam && this.Store.Checkout.Cart.CurrentStep === 0) {
                        this.selectServiceFromUrl();
                    }
                });
            },
            selectServiceFromUrl: function() {
                if (this.urlServiceParam && this.Store.Checkout.Cart) {
                    // Use the same method as clicking the button
                    this.CmdSelectService(this.urlServiceParam);
                }
            }
        },
        computed:
        {
            hasAnyServiceEnabled() {
                return this.Store.TenantConfig && (
                    this.Store.TenantConfig.isServiceEnabledRONNotarization ||
                    this.Store.TenantConfig.isServiceEnabledFieldNotarization ||
                    this.Store.TenantConfig.isServiceEnabledCourier ||
                    this.Store.TenantConfig.isServiceEnabledApostille ||
                    this.Store.TenantConfig.isServiceEnabledFieldInspection
                );
            }
        },
        beforeMount: function () {

        },
        created: function () {
            this.Store = useEditorStore();
            
            // Listen for CartLoaded event
            EventHub.$on('CartLoaded', this.onCartLoaded);
        },
        mounted: function () {
            // Store URL param for later use
            const urlParams = new URLSearchParams(window.location.search);
            this.urlServiceParam = urlParams.get('service');
            
            if (this.urlServiceParam) {
                // Wait a tick to ensure everything is initialized
                this.$nextTick(() => {
                    // If cart is already loaded and we're on step 0, select the service
                    if (this.Store.Checkout.Cart && this.Store.Checkout.Cart.CurrentStep === 0) {
                        this.selectServiceFromUrl();
                    }
                });
            }
        },
        beforeUnmount: function () {
            EventHub.$off('CartLoaded', this.onCartLoaded);
        }
    }
</script>

<style scoped>
.service-picker-container {
    padding: 1.5rem;
    background: #f8f9fa;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.service-section {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.service-header {
    text-align: center;
    font-size: 1.75rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 2rem;
    letter-spacing: -0.025em;
}

.service-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    width: 100%;
}

.service-card-wrapper {
    perspective: 1000px;
}

.service-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 100%;
    min-height: 120px;
}

.service-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    border-color: #667eea;
}

.service-card.selected {
    border-color: #667eea;
    background: #f8f9ff;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.service-icon {
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}

.service-card:hover .service-icon {
    transform: scale(1.1);
}

.service-icon i {
    font-size: 1.5rem;
    color: white;
}

.service-content {
    flex: 1;
    padding-right: 2.5rem;
}

.service-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2d3748;
    margin-bottom: 0.25rem;
    transition: color 0.2s ease;
}

.service-card:hover .service-title {
    color: #667eea;
}

.service-description {
    color: #718096;
    line-height: 1.5;
    font-size: 0.875rem;
    margin: 0;
}

.service-arrow {
    position: absolute;
    right: 1.5rem;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.service-card:hover .service-arrow {
    transform: translateX(4px);
}

.service-arrow i {
    color: #a0aec0;
    font-size: 1rem;
    transition: color 0.2s ease;
}

.service-card:hover .service-arrow i {
    color: #667eea;
}

.service-card.selected .service-arrow i {
    color: #667eea;
}

/* No Services Available Styles */
.no-services-container {
    text-align: center;
    padding: 3rem 2rem;
}

.no-services-content {
    background: white;
    border-radius: 12px;
    padding: 2.5rem;
    max-width: 450px;
    margin: 0 auto;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.no-services-icon {
    width: 60px;
    height: 60px;
    background: #f3f4f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
}

.no-services-icon i {
    font-size: 2rem;
    color: #667eea;
}

.no-services-content h3 {
    color: #2d3748;
    margin-bottom: 0.75rem;
    font-weight: 600;
    font-size: 1.25rem;
}

.no-services-content p {
    color: #718096;
    margin-bottom: 1.5rem;
    line-height: 1.5;
    font-size: 0.875rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .service-picker-container {
        padding: 1rem;
    }
    
    .service-header {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
    }
    
    .service-grid {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
    
    .service-card {
        padding: 1.25rem;
        min-height: 100px;
    }
    
    .service-icon {
        width: 45px;
        height: 45px;
    }
    
    .service-icon i {
        font-size: 1.25rem;
    }
    
    .service-title {
        font-size: 1rem;
    }
    
    .service-description {
        font-size: 0.813rem;
    }
}

/* Animation for card appearance */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.service-card-wrapper {
    animation: fadeIn 0.3s ease-out forwards;
}

.service-card-wrapper:nth-child(1) { animation-delay: 0.05s; }
.service-card-wrapper:nth-child(2) { animation-delay: 0.1s; }
.service-card-wrapper:nth-child(3) { animation-delay: 0.15s; }
.service-card-wrapper:nth-child(4) { animation-delay: 0.2s; }
.service-card-wrapper:nth-child(5) { animation-delay: 0.25s; }
</style>